<template>
  <div class="w-1/2 lg:w-full">
    <div class="border-2 border-gray-400 border-dashed hover:border-transparent hover:bg-white hover:shadow-xl rounded p-6 m-2 md:mx-10 md:my-6">
      <div class="flex flex-col items-center">
        <div class="flex-shrink pr-4">
          <div class="rounded-full p-3 bg-gray-300">
            <fa :icon="icon"
                class="fa-fw fa-inverse text-indigo-500"
            />
          </div>
        </div>

        <div class="flex-1 text-center">
          <h3 class="font-bold text-3xl">
            {{ indicator }}
            <span v-if="secondaryIcon" class="text-yellow-600">
                            <fa :icon="secondaryIcon"/>
                        </span>
          </h3>

          <h5 class="font-bold text-gray-500" v-text="title"></h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    indicator: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    secondaryIcon: {
      type: String,
      default: null
    }
  }
}
</script>
